export default "__VITE_ASSET__ILrhYzq$__"